module.exports = __webpack_public_path__ + "img/68577659000149.1e7f13c4.png";